import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import SanitizedHtml from "../../components/SanitizedHtml";
import { setSubControlsDisabled, toggleSubControls } from "../subControls";
import hasRenderableControl from "../hasRenderableControl";
import buildControl from "../buildControl";

const buildMultiChoiceRadioQuestion = (question) => {
  return (
    <>
      {/* Checkboxes */}
      {question.Options &&
        question.Options.map((o, i) => {
          const subControlsId = `sub_${question.Name}_${o.Name}`;
          return (
            <Form.Check
              type="radio"
              label={o.Label}
              key={i}
              xname={o.Name}
              name={question.Name}
              value={o.Name}
              required={question.IsMandatory}
              onChange={(event) => {
                question.Options.forEach((opt) => {
                  const otherId = `sub_${question.Name}_${opt.Name}`;
                  toggleSubControls(otherId, false);
                });

                toggleSubControls(subControlsId, true);
              }}
            ></Form.Check>
          );
        })}

      {/* Sub-controls for all options, rendered after all radio buttons */}
      {question.Options &&
        question.Options.map((o, i) => {
          const subControlsId = `sub_${question.Name}_${o.Name}`;
          return (
            o.Questions && (
              <div
                key={i}
                id={subControlsId}
                className="ms-4"
                style={{ display: "none" }}
                ref={(el) => setSubControlsDisabled(el, true)}
              >
                {o.Questions.map((subQuestion, si) =>
                  hasRenderableControl(subQuestion) ? (
                    <Card className="mb-3" key={si}>
                      <Card.Body>
                        <Card.Title as="div">
                          <div className="d-flex align-items-start">
                            {subQuestion.IsMandatory && (
                              <span className="text-danger me-1">*</span>
                            )}

                            <SanitizedHtml
                              html={subQuestion.MainText}
                              className="question-main-text"
                            />
                          </div>
                        </Card.Title>

                        <SanitizedHtml
                          html={subQuestion.Description}
                          className="card-text question-description"
                        />
                        <Form.Group
                          className="mb-3"
                          data-error-text={subQuestion.ErrorText || ""}
                        >
                          {buildControl(subQuestion)}
                        </Form.Group>
                      </Card.Body>
                    </Card>
                  ) : null,
                )}
              </div>
            )
          );
        })}

      {/* Other input */}
      {question.AddOther && (
        <Form.Control
          type="text"
          name={`${question.Name}_other`}
          placeholder="Please specify"
          className="mt-2"
        />
      )}
    </>
  );
};

export default buildMultiChoiceRadioQuestion;
